import React, { ReactNode } from 'react';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SaveIcon from '@mui/icons-material/Save';
import { Box, Button, CircularProgress, Stack } from '@mui/material';

interface TagFormHeaderProps {
  mode: 'create' | 'edit';
  isSaving: boolean;
  isSaveDisabled?: boolean;
  nameInput?: ReactNode;
  tagTypeInput?: ReactNode;
  onViewContent?: () => void;
  onBack: () => void;
  onSave: () => void;
}

export default function TagFormHeader({
  mode,
  isSaving = false,
  isSaveDisabled = false,
  nameInput,
  tagTypeInput,
  onViewContent,
  onBack,
  onSave,
}: TagFormHeaderProps) {
  return (
    <Stack spacing={2} mb={3}>
      <Box display="flex" alignItems="center" justifyContent="space-between" gap={2}>
        <Button variant="text" startIcon={<ArrowBackIcon />} onClick={onBack}>
          Back to List
        </Button>
        <Box display="flex" justifyContent="flex-end" alignItems="center" gap={2}>
          {onViewContent && (
            <Button variant="text" onClick={onViewContent}>
              View content
            </Button>
          )}
          <Button
            variant="contained"
            startIcon={isSaving ? <CircularProgress size={20} /> : <SaveIcon />}
            onClick={onSave}
            disabled={isSaveDisabled || isSaving}
          >
            {mode === 'edit' ? 'Save changes' : 'Save'}
          </Button>
        </Box>
      </Box>
      <Stack direction="row" spacing={2} alignItems="flex-start">
        {nameInput && <Box sx={{ flex: 1 }}>{nameInput}</Box>}
        {tagTypeInput && <Box sx={{ flex: 1 }}>{tagTypeInput}</Box>}
      </Stack>
    </Stack>
  );
}
